/**
 * `POST /api/stripe/connect/disconnect` — release the seller's Stripe Connect
 * link from Kraahl. The upstream Stripe account is left intact (orphan); we
 * delete our `seller_stripe_accounts` row and reset payout preferences back
 * to PayPal.
 *
 * `ok: true` is the apiJson success sentinel — the route never returns
 * `ok: false` (errors go through `apiError`). Clients branch on HTTP status,
 * then read `ok` opportunistically.
 *
 * @see app/api/stripe/connect/disconnect/route.ts — handler
 */

import { z } from "zod";
import { pinned } from "./pin";

export interface StripeConnectDisconnectResponse {
  ok: true;
}

export const StripeConnectDisconnectResponseSchema =
  pinned<StripeConnectDisconnectResponse>()(
    z.object({
      ok: z.literal(true),
    }),
  );
